import { Theme } from "@mui/material/styles";

const EXCEPTIONS = '&.MuiAccordion-root, &.MuiAutocomplete-paper, &.MuiAlert-root';

const buildOutlinedElevation = (level: 1 | 2) => ({ theme }: { theme: Theme }) => {
  const borderColor = theme.palette?.divider || theme.palette.other?.outlinedBorder

  return {
    boxShadow: 'none',
    border: `1px solid ${borderColor}`,
    [EXCEPTIONS]: {
      border: 'none',
      boxShadow: theme.shadows[level],
    },
  };
};

export const MuiPaperOverrides = {
  styleOverrides: {
    elevation1: buildOutlinedElevation(1),
    elevation2: buildOutlinedElevation(2),
  },
};
